import { render } from "./CashAdvanceModal.vue?vue&type=template&id=2a21504a&scoped=true"
import script from "./CashAdvanceModal.vue?vue&type=script&lang=js"
export * from "./CashAdvanceModal.vue?vue&type=script&lang=js"

import "./CashAdvanceModal.vue?vue&type=style&index=0&id=2a21504a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a21504a"]])

export default __exports__